<template>
    <div containerClass="card p-10">
       
        <div class="stepper stepper-pills" id="kt_stepper_example_clickable">
            <div class="stepper-nav flex-center flex-wrap mb-10 d-none">
                <div 
                    v-for="(step, index) in activeSteps" 
                    :key="step.id"
                    :class="['stepper-item', 'mx-2', 'my-4', { 'current': index === 0 }]"
                    data-kt-stepper-element="nav" 
                    data-kt-stepper-action="step">
                </div>
                
            </div>

            <form class="form "  id="kt_stepper_example_basic_form">
                <div class="mb-5">
                    <div class="flex-column current" data-kt-stepper-element="content" data-step-index="1">
                        <section class="card shadow-sm pt-5 px-5 mb-10 event-header border-topYellow">
                            <h2 class="event-title mb-5 text-uppercase fs-2hx">
                            {{ "INSCRIPTION RE-BRAND : YOUR LEADERSHIP EDITION 5" }}
                            </h2>
                            <div class="event-description mb-5" >
                                <p  class="fs-1 text-justify">
                                Cette Edition placée sous le thème de : 
                                <strong>« DU LEADERSHIP A LA GOUVERNANCE ET AUX PERFORMANCES COMMERCIALES DANS LES ORGANISATIONS ET ENTREPRISES AFRICAINES. » </strong> vise à explorer comment les leaders peuvent à travers des panels et des ateliers transiter d’une gestion opérationnelle vers une approche plus stratégique plus large axée sur la durabilité et l’efficacité organisationnelle pour une excellence commerciale.
                                Organisé par le <strong>GROUP SENAKPON</strong>, cet évènement rassemble des experts, des leaders des entrepreneurs et des professionnels de divers secteurs pour partager leurs expériences, leurs stratégies et leurs outils nouveaux
                                </p>
                                <div class="d-flex align-items-center" style="margin-bottom: 10px">
                                    <svg :key="$i18n.locale" width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><title></title><g id='页面-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><g id='System' transform='translate(-672.000000, 0.000000)' fill-rule='nonzero'><g id='information_line' transform='translate(672.000000, 0.000000)'><path d='M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z' id='MingCute' fill-rule='nonzero'></path><path d='M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M12,4 C7.58172,4 4,7.58172 4,12 C4,16.4183 7.58172,20 12,20 C16.4183,20 20,16.4183 20,12 C20,7.58172 16.4183,4 12,4 Z M11.99,10 C12.5478,10 13,10.4522 13,11.01 L13,16.1338 C13.2989,16.3067 13.5,16.6299 13.5,17 C13.5,17.5523 13.0523,18 12.5,18 L12.01,18 C11.4521,18 11,17.5478 11,16.99 L11,12 C10.4477,12 10,11.5523 10,11 C10,10.4477 10.4477,10 11,10 L11.99,10 Z M12,7 C12.5523,7 13,7.44772 13,8 C13,8.55228 12.5523,9 12,9 C11.4477,9 11,8.55228 11,8 C11,7.44772 11.4477,7 12,7 Z' id='形状' fill='#F07817FF'></path></g></g></g></svg>
                                    <span class="badge" style=" padding: 5px;" >
                                        <span class="text-gray-200 fs-1 text-warning fw-semibold fs-6 text-wrap text-start" style="color: #f07817!important;"> {{ $t('required_text') }}</span>
                                </span>
                                </div>
                            </div>
                        </section>
                       <Card containerClass="card  p-10">
                            <div class="col-12 mt-2 mb-8" >
                                <label class="form-label fs-3 text-black required mb-3">{{ $t("google.lastname") }}</label>
                                <input type="text" v-model="formData.lastname" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.lastname')" required>
                            </div>
                            <div class="col-12 mt-2 mb-8" >
                                <label class="form-label fs-3 text-black required mb-3">{{ $t("google.firstname") }}</label>
                                <input type="text" v-model="formData.firstname" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.firstname')" required>
                            </div>
                            <div class="col-12 mt-2 mb-8" >
                                <label class="form-label fs-3 text-black required mb-3">{{ $t("google.email") }}</label>
                                <input type="email" v-model="formData.email" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.email')" required>
                            </div>
                            <InputTel
                                containerClass="col-12 mt-2 mb-8"
                                :name="`${id}-phone`"
                                phoneCode="+228"
                                type="text"
                                :label="$t('user.phone')+ '(Whatsapp)'"
                                labelClass="form-label fs-3 text-black"
                                inputClass="form-control form-control-lg form-control-solid"
                                v-model:phone="formData.phone"
                                v-model:phone-code="formData.phone_code"
                                :placeholder="$t('enter_phone')"
                                :isRequired="true" />
                            
                            <div class="col-12 mt-2 mb-8" >
                                <label class="form-label fs-3 text-black  mb-3">{{ $t("google.code") }}</label>
                                <input type="text" v-model="formData.code_promo" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.code')">
                            </div>
                       </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="2">
                        <Card :title="'DIFFERENTS PROGRAMMES DE L\'EVENEMENT'" containerClass="card p-0 senakpon">
                            <div class="p-10">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <label class="form-label fs-3 text-black required mb-3">{{ "Merci de crocher les cases correspondantes aux programmes que vous souhaitez participer." }}</label>
                                </div>
                                <CheckboxGroupInput :options="programs" v-model="selectedPrograms"/>
                                <div class="checkbox-group">
                                    <div class="form-check form-check-custom form-check-solid mb-2">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox"
                                        id="all"
                                        v-model="all"
                                    />
                                    <label for="all" class="form-check-label fs-6 fw-bolder text-black">
                                        PARTICIPER A TOUS LES ATELIERS
                                    </label>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="3" v-if="selectedPrograms.includes(PROGRAMS.PROGRAM_1)">
                        <Card :title="'PARTICIPATION AUX ATELIERS'" containerClass="card p-0 senakpon">
                            <div class="p-10">
                                <label class="form-label fs-3 text-black required mb-3">{{ "Merci de sélectionner les deux cases ci-dessous." }}</label>
                                <div class="checkbox-list mb-8">
                                    <CheckboxGroupInput id="workshops" :options="worshops" v-model="formData.workshops"/>
                                </div>
                                <div class="col-12 mt-2 mb-8" >
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.numberParticipator") }}</label>
                                    <input type="number" :min="1" v-model="formData.workshopParticipantCount" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.lastname')" required>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="4" v-if="selectedPrograms.includes(PROGRAMS.PROGRAM_1)">
                        <Card :title="'PARTICIPANTS'" containerClass="card p-0 senakpon">
                            <div class="py-10 px-5">
                                <div class=" card p-4 shadow  mb-8" v-for="(participator, index) in formData.workshopParticipants" :key="index">
                                    <h3>Participant {{ index+1 }}</h3>
                                    <div class="row mt-2">
                                        <div class="col-12 col-lg-3 col-md-3  mb-3 mb-3">
                                            <label class="form-label fs-3 text-black required mb-3">{{ $t("google.lastname") }}</label>
                                            <input type="text" v-model="participator.lastname" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.lastname')" required>
                                        </div>
                                        <div class="col-12 col-lg-3 col-md-3  mb-3 ">
                                            <label class="form-label fs-3 text-black required mb-3">{{ $t("google.firstname") }}</label>
                                            <input type="text" v-model="participator.firstname" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.firstname')" required>
                                        </div>
                                        <div class="col-12 col-lg-3 col-md-3  mb-3 ">
                                            <label class="form-label fs-3 text-black required mb-3">{{ $t("google.email") }}</label>
                                            <input type="email" v-model="participator.email" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.email')" required>
                                        </div>
                                        <div class="col-12 col-lg-3 col-md-3">
                                            <InputTel
                                                containerClass="col-12 mt-2 mb-8"
                                                :name="`${id}-p`"
                                                phoneCode="+228"
                                                type="text"
                                                :label="$t('user.phone')+ '(Whatsapp)'"
                                                labelClass="form-label fs-3 text-black"
                                                inputClass="form-control form-control-lg form-control-solid"
                                                v-model:phone="participator.phone"
                                                v-model:phone-code="participator.phone_code"
                                                :placeholder="$t('enter_phone')"
                                                :isRequired="true" />
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="5" v-if="selectedPrograms.includes(PROGRAMS.PROGRAM_2)">
                        <Card :title="'PARTICIPATION A LA CEREMONIE DE DEDICACE ET A LA  CONFERENCE '" containerClass="card p-0 senakpon">
                            <div class="p-10">
                                <div class="fw-bold fs-1 mb-4">
                                    DEDICACE DE LIVRE DES PROVERBES AFRICAINS AU LEADERSHIP  ET  AU  DEVELOPPEMENT PERSONNEL
                                </div>
                                <div class="mb-4" style="width: 100%; "><img src="https://lh7-rt.googleusercontent.com/formsz/AN7BsVDsl1A9cc6ZSMF2ItxNotyUfj22j5VAunvr4PlYqvIh9zLni8NDCgo1zNJoTpYKuvmYNUty8na4a9Lp-4G2cc-xZtSrRu5YH51NLEy9QpUyE7Jpxphrn2NmatjGvPap7hell41sUJE5tjfBfHGaZ7yFz-2sksLNv-vui08I9DaL2V7a7EqM8ESbF5dbAdAOrurJU-KhA_LuV2A=w1748?key=AhQcTT4GZEEQ0s8d9VBUpw" class="HxhGpf" style="width: 100%; " title="" alt=""></div>
                                <br><br>
                                <label class="form-label fs-3 text-black required mb-3">{{ "Merci de sélectionner les deux cases ci-dessous." }}</label>
                                <div class="checkbox-list mb-2">
                                    <CheckboxGroupInput id="books" :options="books" v-model="formData.bookCeremony"/>
                                </div>
                               
                                <div class="col-12 mt-2 mb-8" >
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.bookNumber") }}</label>
                                    <input type="number" :min="1" v-model="formData.bookCount" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.lastname')" required>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="6" v-if="selectedPrograms.includes(PROGRAMS.PROGRAM_3)">
                        <Card :title="'PARTICIPATION AU DINER GALA  '" containerClass="card p-0 senakpon">
                            <div class="p-10">
                                <h1><a target="_blank" href="https://www.google.com/url?sa=j&url=https%3A%2F%2Fwww.rebrandyourleadership.com%2Fetn%2Fdiner-gala-theme-ceremonie-de-recompenses%2F&uct=1756166701&usg=Ke--XnMhckTI6irarnUKY_Cvwvk.&source=editors">DINER GALA : DU LEADERSHIP A LA GOUVERNANCE ET AUX PERFORMANCES COMMERCIALES DANS LES ORGANISATIONS ET ENTREPRISES AFRICAINES”</a></h1>
                               
                                <div class="col-12 mt-10 mb-8" >
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.galaParticipator") }}</label>
                                    <input type="number" :min="1" v-model="formData.galaParticipantCount" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.lastname')" required>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="7" v-if="selectedPrograms.includes(PROGRAMS.PROGRAM_3)">
                        <Card :title="'PARTICIPANTS DU GALA'" containerClass="card p-0 senakpon">
                            <div class="p-10">
                                 <div class=" card p-4 shadow  mb-8"  v-for="(galaParticipator, index) in formData.galaParticipants" :key="index">
                                    <h3>Participant {{ index+1 }}</h3>
                                    <div class="row mt-2">
                                        <div class=" col-12 col-lg-3 col-md-3">
                                            <label class="form-label fs-3 text-black required mb-3">{{ $t("google.lastname") }}</label>
                                            <input type="text" v-model="galaParticipator.lastname" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.lastname')" required>
                                        </div>
                                        <div class="col-12 col-lg-3 col-md-3  mb-3 ">
                                            <label class="form-label fs-3 text-black required mb-3">{{ $t("google.firstname") }}</label>
                                            <input type="text" v-model="galaParticipator.firstname" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.firstname')" required>
                                        </div>
                                        <div class="col-12 col-lg-3 col-md-3  mb-3 ">
                                            <label class="form-label fs-3 text-black required mb-3">{{ $t("google.email") }}</label>
                                            <input type="email" v-model="galaParticipator.email" class="form-control form-control-solid form-control-lg" :placeholder="$t('google.email')" required>
                                        </div>
                                        <div class="col-12 col-lg-3 col-md-3">
                                            <InputTel
                                                containerClass="col-12 mt-2 mb-8"
                                                :name="`${id}-p`"
                                                phoneCode="+228"
                                                type="text"
                                                :label="$t('user.phone')+ '(Whatsapp)'"
                                                labelClass="form-label fs-3 text-black"
                                                inputClass="form-control form-control-lg form-control-solid"
                                                v-model:phone="galaParticipator.phone"
                                                v-model:phone-code="galaParticipator.phone_code"
                                                :placeholder="$t('enter_phone')"
                                                :isRequired="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="8" v-if="selectedPrograms.includes(PROGRAMS.PROGRAM_4)">
                        <Card :title="'RESERVATION DE SEANCE DE COACHING RE-BRAND'" containerClass="card p-0 senakpon">
                            <div class="p-10">
                                <h3 class="mb-4">Ce formulaire vous permet de réserver une séance de coaching avec l'un de nos panelistes experts. Vous avez le choix entre un coaching individuel ou de groupe.  </h3>
                            </div>
                            <div class="p-10">
                                <div class="col-12 mt-2 mb-8" >
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.coachingType") }}</label>
                                   <RadioGroup :column="true" :options="coachings" v-model="formData.coachingType"/>
                                </div>
                                <div class="col-12 mt-2 mb-8" v-if="formData.coachingType == coachings[1]">
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.galaParticipator") }}</label>
                                    <input type="number" :min="1" :max="10" v-model="formData.coachingParticipantCount" class="form-control form-control-solid form-control-lg" required>
                                </div>
                                 <div class="col-12 mt-2 mb-8" >
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.paneliste") }}</label>
                                    <ImageRadioGroup :options="panelistes" v-model="formData.coach"/>
                                </div>
                                <div class="col-12 mt-2 mb-8" >
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.object") }}</label>
                                    <input type="text"  v-model="formData.coachingObject" class="form-control form-control-solid form-control-lg"  required>
                                </div>
                                <div class="col-12 mt-2 mb-8" >
                                    <label class="form-label fs-3 text-black required mb-3">{{ $t("google.comment") }}</label>
                                    <textarea rows="4"  v-model="formData.coachingComment" class="form-control form-control-solid form-control-lg"  required></textarea>
                                </div>
                            </div>
                        </Card>
                    </div>

                    <div class="flex-column" data-kt-stepper-element="content" data-step-index="9">
                        <Card :title="'PAIEMENT'" containerClass="card p-0 senakpon">
                            <div class="p-10">
                                <h1>Choisir votre méthode de paiement. </h1>
                                <RadioGroup :options="payments" v-model="formData.payment_method"/>
                            </div>
                        </Card>
                    </div>
                </div>

                
                <div class="d-flex flex-stack">
                    <div class="me-2">
                        <button type="button" class="btn btn-light btn-active-light-primary" data-kt-stepper-action="previous">
                             {{$t('button.back')}}
                        </button>
                    </div>

                    <div> 
                        <button type="button" class="btn btn-primary" data-kt-stepper-action="submit" @click="submitQuestion">
                            <span class="indicator-label">
                                 {{$t('button.send')}}
                            </span>
                            <span class="indicator-progress">
                                Platienter svp... <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>

                        <button type="button" class="btn btn-primary" @click.prevent="goToNext" data-kt-stepper-action="next">
                            {{$t('button.next')}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
            
    </div>
</template>
<script setup>
import InputTel from '@/components/InputTel.vue';
import Card from '@/components/Card.vue';
import { ref, onMounted, watch, nextTick } from 'vue';
import {useStore} from "vuex";
import ImageRadioGroup from '@/components/ImageRadioGroup.vue';
import RadioGroup from '@/components/Form/Radio/RadioGroup.vue';
import CheckboxGroupInput from '@/components/CheckboxGroupInput.vue';
import { computed } from 'vue';
import i18n from '@/plugins/i18n';
import { useRoute } from 'vue-router';
import {useSwal} from "@/composables/useSwal";

const emits = defineEmits(["close"]);

const store = useStore()
const route = useRoute()
const {showSwal} = useSwal()

const props = defineProps({
    event: {
        type: String,
        default: ''
    }
})
const PROGRAMS = {PROGRAM_1: 'PROGRAM_1', PROGRAM_2: 'PROGRAM_2', PROGRAM_3: 'PROGRAM_3', PROGRAM_4: 'PROGRAM_4'}
const programs = [
    {key: "PROGRAM_1", value: 'LES WORKSHOPS 1 & 2  (50 000 fcfa  HT)'},
    {key: 'PROGRAM_2', value: 'CEREMONIE DE DEDICACE ET  CONFERENCE (10 000 fcfa HT)'},
    {key: 'PROGRAM_3', value: 'PARTICIPATION AU DINER GALA  (50 000 FCFA HT'},
    {key: 'PROGRAM_4', value: 'RESERVATION DE SEANCE DE COACHING RE-BRAND'},
]

const getProgramLabel = (key) => {
    const program = programs.find(p=>p.key ===key);
    return program ? program.value : key;
}

const worshops = [{value:'WORKSHOP I: LEADERSHIP ET GOUVERNANCE', key:'WORKSHOP I: LEADERSHIP ET GOUVERNANCE'}, {value:'WORKSHOP II: LEADERSHIP & PERFORMANCES COMMERCIALES', key: 'WORKSHOP II: LEADERSHIP & PERFORMANCES COMMERCIALES'}]
const books = [{value:'CEREMONIE DE DEDICACE DE LIVRE', key:'CEREMONIE DE DEDICACE DE LIVRE'}, {value:'CONFERENCE : JE RELEVE LE DEFI', key: 'CONFERENCE : JE RELEVE LE DEFI'}]
const coachings = ['Coaching individuel (Une personne, durée 35 minutes / Coût : 75.000 F)', 'Coaching de groupe (Maximum 10 personnes, durée 1h30 / Coût : 50.000 F par personne)']
const panelistes = [
    {name: 'Stéphan CORIDON', img: 'https://lh7-rt.googleusercontent.com/formsz/AN7BsVAMczgS8LTrkqYicVQjrv1fKNiFEcU2GTd7Gzb50o2OSnRWrmjkBct9a9krY9fiicFgMm999dDmL7gBH__OokfPIyyOIW4HRyAwsNVddlHgLJjskrfl_jAXbIrh0at58TgjCC8fpm5CHLURKmStdAjVKvbm9RhmYHcf8CFkFbVI83_nEPEauhylhgDb_mUntuafPi982edFrR9U=w260?key=AhQcTT4GZEEQ0s8d9VBUpw'},
    {name: 'Nabou FALL', img: 'https://lh7-rt.googleusercontent.com/formsz/AN7BsVA11VHzhPRbJWC2J46uBRHbvagx2xRDjGWqpTfuIU5w5TJ9fEf9fEQQZklFEIDyIfoz368t-jGgRCd8ZNepldkP9o3_-2afb86kzQ_fkuR9bugzV9BmAn6hz0om57qLY5oqUhuNmkQgmnAHXYKtMNhsuqymG8w7Rc1wKZrYN_F6C-2iQsWQe-ukgDJbeYa2bEnUnwh8R3OZwzqG=w260?key=AhQcTT4GZEEQ0s8d9VBUpw'},
    {name: 'Antonin DOSSOU', img: 'https://lh7-rt.googleusercontent.com/formsz/AN7BsVAYr4wykendguMuX6Nhm5n42sIHRau5hyrC_g9eenb6AHb7okJr3o0XF65_p0pg_CJqJg1dZmF224MluwRHG1QGEuL7e1hO9H9wsVSSCSGrHe7ngrfo0i23Jn49OWlpJcO1gHOvkUzCwuZafwrfgwpoaj0XOT9O6FphZoWzB1XvhGPZShaZ0R9YpyzGnDt9wxGs4uANk6BSu6NM=w260?key=AhQcTT4GZEEQ0s8d9VBUpw'},
    {name: 'Adjaratou LAWANI', img: 'https://lh7-rt.googleusercontent.com/formsz/AN7BsVDKiuwfUGc7zJUbrRGbWSVBp-HRO6Vwy8deIEit3SXTAWb3Md1DypdTnYGdIpPc6IKBTSiOJCVcZKLnkSj7KYjRGYswKkwf9IrLWkXj2E3L7fLRTDhkB6QZh5jFV5sgRLSIpRg_g6r5nosbXwYwJXKhd-tWief9zIV3vPXNirZhdI8VjSVM2JGZYUSJDbg8ZO0gKlSYhcw5XB8T=w260?key=AhQcTT4GZEEQ0s8d9VBUpw'}
]
const payments = ['Flooz (+22898068985)', 'T-money (+22892860146)', 'X - Press', 'En espèce (Passez au cabinet)', 'MoneyGram', 'Western Union']

const selectedPrograms = ref([])
const stepper = ref('')
const isSubmitting = ref(false)
const all = ref(false)
const currentStep = ref(null)
const formData =ref({
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    phone_code: '',
    code_promo: '',
    selectedPrograms: [],
    workshops: [],
    workshopParticipantCount: 1,
    workshopParticipants: [{
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        phone_code: ''
    }],
    bookCeremony: [],
    bookCount: 1,
    galaParticipantCount: 1,
    galaParticipants: [{
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        phone_code: ''
    }],
    coachingType: '',
    coachingParticipantCount: 1,
    coach: '',
    coachingComment: '',
    coachingObject: '',
    payment_method: ''
})

const activeSteps = computed(() => {
    const steps = [
        { id: 'step-personnel', nav_index: 1, content_index: 1 },
        { id: 'step-programs', nav_index: 2, content_index: 2 },
    ];

    if (selectedPrograms.value.includes(PROGRAMS.PROGRAM_1)) {
        steps.push({ id: 'step-workshop', nav_index: 3, content_index: 3 });
        steps.push({ id: 'step-workshop-participants', nav_index: 4, content_index: 4 });
    }
    if (selectedPrograms.value.includes(PROGRAMS.PROGRAM_2)) {
        steps.push({ id: 'step-dedicace', nav_index: 5, content_index: 5 });
    }
    if (selectedPrograms.value.includes(PROGRAMS.PROGRAM_3)) {0

        steps.push({ id: 'step-gala', nav_index: 6, content_index: 6 });
        steps.push({ id: 'step-gala-participants', nav_index: 7, content_index: 7 });
    }
    if (selectedPrograms.value.includes(PROGRAMS.PROGRAM_4)) {
        steps.push({ id: 'step-coaching', nav_index: 8, content_index: 8 });
    }

    steps.push({ id: 'step-payment', nav_index: steps.length + 1, content_index: 9 });

    return steps;
});


watch(
  () => formData.value.workshopParticipantCount,
  () => {
    formData.value.workshopParticipants = Array.from(
      { length: formData.value.workshopParticipantCount },
      () => ({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        phone_code: ''
      })
    )

    if (formData.value.workshopParticipants.length > 0) {
      formData.value.workshopParticipants[0] = {
        firstname: formData.value.firstname,
        lastname: formData.value.lastname,
        email: formData.value.email,
        phone: formData.value.phone,
        phone_code: formData.value.value
      }
    }
  }, { immediate: true }
)

watch(
  () => formData.value.phone,
  () => {
    if (formData.value.workshopParticipants.length > 0) {
      formData.value.workshopParticipants[0] = {
        firstname: formData.value.firstname,
        lastname: formData.value.lastname,
        email: formData.value.email,
        phone: formData.value.phone,
        phone_code: formData.value.value
      }
    }

     if (formData.value.galaParticipants.length > 0) {
      formData.value.galaParticipants[0] = {
        firstname: formData.value.firstname,
        lastname: formData.value.lastname,
        email: formData.value.email,
        phone: formData.value.phone,
        phone_code: formData.value.value
      }
    }
  }, { immediate: true }
)


watch(
  () => formData.value.galaParticipantCount,
  () => {
    formData.value.galaParticipants = Array.from(
      { length: formData.value.galaParticipantCount },
      () => ({
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        phone_code: ''
      })
    )

    if (formData.value.galaParticipants.length > 0) {
      formData.value.galaParticipants[0] = {
        firstname: formData.value.firstname,
        lastname: formData.value.lastname,
        email: formData.value.email,
        phone: formData.value.phone,
        phone_code: formData.value.value
      }
    }
  }, { immediate: true }
)


watch(() => all.value, () => {
    if(all.value){
        selectedPrograms.value = Object.values(PROGRAMS)
    }else if(selectedPrograms.value?.length == 4){
        selectedPrograms.value = []
    }
    
}, {immediate: true})

watch(() => selectedPrograms.value, () => {
    nextTick(() => {
        initStepper()
    })
    
    if(selectedPrograms.value?.length < 4){
        all.value = false
    }
    
}, {immediate: true})

function goToNext(){
    console.log("goToNext", stepper.value.getCurrentStepIndex())
    if(validateStep(stepper.value.getCurrentStepIndex())){
        if(stepper.value.getCurrentStepIndex() < currentStep.value){
            stepper.value.goTo(currentStep.value+1)
        }else{
            stepper.value.goNext(); 
        }
        currentStep.value = stepper.value.getCurrentStepIndex()

    }else{
        showSwal(
            'Erreur',
            i18n.global.t('required_text'),
            'info',
            '',
            false
        )
    }

}

function validateParticipants(participants) {
  for (const [index, p] of participants.entries()) {
    if (
      !p.firstname.trim() ||
      !p.lastname.trim() ||
      !p.email.trim() ||
      !p.phone.trim() 
    ) {
      return false;
    }
  }
  return true;
}

function validateStep(stepIndex){
    
    switch (activeSteps.value[stepIndex-1]?.id) {
        case "step-personnel":
            return  formData.value.lastname && formData.value.firstname && formData.value.phone && formData.value.email
        case 'step-programs':
            return selectedPrograms.value?.length > 0;
        case "step-workshop":
            return formData.value.workshops?.length > 0;
        case "step-workshop-participants":
            return validateParticipants(formData.value.workshopParticipants);
        case "step-dedicace":
            return formData.value.bookCeremony?.length > 0;
        case "step-gala": 
            return formData.value.galaParticipantCount > 0;
        case "step-gala-participants":
            return validateParticipants(formData.value.galaParticipants);
        case "step-coaching":
            return formData.value.coachingType && formData.value.coach && formData.value.coachingComment && formData.value.coachingObject; 
        case "step-payment":
            return !!formData.value.payment_method;
        default:
            return true;
    }

  
    
}



function initStepper(){    
    
    if (stepper.value && stepper.value.destroy) {
        stepper.value.destroy()
        stepper.value = null; 
    }

    const element = document.querySelector("#kt_stepper_example_clickable")

    if (!element) return

    stepper.value = new KTStepper(element);

    stepper.value.on("kt.stepper.click", function (stepper) {
        
        stepper.goTo(stepper.getClickedStepIndex());
    });

    stepper.value.on("kt.stepper.next", function (stepper) {
       
    });

    stepper.value.on("kt.stepper.previous", function (stepper) {
        stepper.goPrevious(); 
        currentStep.value = stepper.getCurrentStepIndex()

    });
 }


  function submitQuestion() {
    if(formData.value.payment_method){
      showSwal(
          '',
          i18n.global.t('google.submit')
      ).then(async (result) => {
        if (result.value) {
            isSubmitting.value = true
            console.log("submitted")
            const data = {
                id: route.params.id,
                ...formData.value,
                selectedPrograms: selectedPrograms.value,
                coachingRequest: {
                    object: formData.value.coachingObject,
                    comment: formData.value.coachingComment
                }
            }
            store
                .dispatch('forms/submitGoogleFormInscription', data)
                .then(() => {
                    emits('close')
                    window.toastr["success"](i18n.global.t('google.success'));
                })
                .catch((e) => {
                }).finally(() => isSubmitting.value = false); 
        }
     })
    }
  }

onMounted(() => {
    initStepper()
 
})
</script>
<style >
.senakpon .card-header{
    background-color:  #FEBB39 !important;
}
.senakpon .card-title{
    color: "#fff" !important;
    font-size: 24px !important;
}
.form-check-label{
    font-size: 12px !important;
    font-weight: 300 !important;
}
.checkbox-group {
  display: flex;
  flex-direction: column;
}
.form-check.form-check-solid .form-check-input:checked {
  background-color: var(--bs-primary);
  border-color: var(--bs-primary); 
}

.form-check.form-check-solid .form-check-input {
    border: 0;
    background-color: #eff2f5;
}

.event-header {
  
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%; 
    height: 20%;            
    margin: 15px auto 30px auto;       
    border-radius: 12px;   
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    text-align: center;
  }

  .border-topYellow{
  border-top: #FEBB39 10px solid;
  border-radius: 12px;

  }

  .event-title {
    margin-top: 12px;
    font-weight: 800;
    color: #333333;
    text-align: left;
  }

  .event-description {
    font-size: 1em;
    line-height: 1.6;
    color: #555555;
    text-align: left;
  }

</style>